/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Work_SInputs */

const en_funnel_ob_seg_work_s = /** @type {(inputs: Funnel_Ob_Seg_Work_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reports, PDFs, long emails`)
};

const es_funnel_ob_seg_work_s = /** @type {(inputs: Funnel_Ob_Seg_Work_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informes, PDF, correos largos`)
};

/**
* | output |
* | --- |
* | "Reports, PDFs, long emails" |
*
* @param {Funnel_Ob_Seg_Work_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_work_s = /** @type {((inputs?: Funnel_Ob_Seg_Work_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Work_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_work_s(inputs)
	return en_funnel_ob_seg_work_s(inputs)
});